import React from 'react'
import {PAYMENT_PROVIDER_CONFIG} from '../../../forms/AddNewDeviceForm/NewDeviceFormComponents/PaymentProviderFieldsComponent/paymentProviderConfig'

const ProviderStatusBadge = ({enabled, t}) => (
    <span className={`detail-view__tag detail-view__tag--${enabled ? 'success' : 'error'}`}>
        {enabled ? t('common.detailPages.access') : t('common.detailPages.decline')}
    </span>
)

const ProviderFieldValue = ({value, t}) => {
    if (value === null || value === undefined || value === '') {
        return (
            <span className="detail-view__tag detail-view__tag--empty">
                {t('common.detailPages.empty')}
            </span>
        )
    }

    return <span className="payment-provider__value-text">{value}</span>
}

const DevicePaymentProvidersView = ({device, t}) => {
    return (
        <div className="payment-providers">
            {PAYMENT_PROVIDER_CONFIG.map((provider) => (
                <section className="payment-provider" key={provider.name}>
                    <div className="payment-provider__header">
                        <div className="payment-provider__title">
                            <img
                                src={provider.logo}
                                alt={provider.name}
                                className="payment-provider__logo"
                            />
                            <h3>{provider.name}</h3>
                        </div>
                        <ProviderStatusBadge
                            enabled={Boolean(device?.[provider.switchKey])}
                            t={t}
                        />
                    </div>

                    <div className="payment-provider__fields">
                        {provider.fields.map((field) => (
                            <div className="payment-provider__field" key={field.key}>
                                <span>{field.label}</span>
                                <div className="payment-provider__value">
                                    <ProviderFieldValue value={device?.[field.key]} t={t}/>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            ))}
        </div>
    )
}

export default DevicePaymentProvidersView
